import useSize from "../../../../Utils/useSize/useSize";
import Menu from "./Menu/Menu";
import Filter from "./Filter/Filter";
import StandingCard from "./StandingCard/StandingCard";
import { useMemo } from "react";

export default function Standing({ item = {}, close }) {
  const windowSize = useSize();
  const userType = Number(localStorage.getItem("user_type") || 7);

  // ✅ Memoized to avoid re-renders
  const standings = useMemo(() => item?.standing || [], [item]);

  return (
    <div
      className="background border primary-border"
      style={{
        width: windowSize[0] - 200,
        height: windowSize[1] - 120,
        borderRadius: 10,
      }}
    >
      <Filter close={close} />
      <Menu userType={userType} />

      <div
        style={{
          height: windowSize[1] - 235,
          display: "flex",
          flexDirection: "column",
        }}
      >
        {standings.length > 0 ? (
          standings.map((data, index) => (
            <StandingCard
              key={data.id || index}
              item={data}
              total={standings.length}
              userType={userType}
            />
          ))
        ) : (
          <div
            className="center text-sm text-gray-400"
            style={{
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            No Standing Data Found.
          </div>
        )}
      </div>
    </div>
  );
}
